module.exports = __webpack_public_path__ + "img/course.2fc1eb32.png";